export default {
    translation: {
        "Ürün Yönetimi": "Ürün Yönetimi",
        "Anasayfa": "Anasayfa",
        "Hızlı Satış": "Hızlı Satış",
        "Çalışan ve Maaşlar": "Çalışan ve Maaşlar",
        "Tüm Ürünler": "Tüm Ürünler",
        "Gelecek Ürünler": "Gelecek Ürünler",
        "Silinen Ürünler": "Silinen Ürünler",
        "Kiradaki Ürünler": "Kiradaki Ürünler",
        "Terzideki Ürünler": "Terzideki Ürünler",
        "Kuru Temizlemedeki Ürünler": "Kuru Temizlemedeki Ürünler",
        "Yeni Ürün Siparişi": "Yeni Ürün Siparişi",
        "Kasa": "Kasa",
        "Günlük Kasa": "Günlük Kasa",
        "Geçmiş Gün Sonları": "Geçmiş Gün Sonları",
        "Genel Giderler": "Genel Giderler",
        "Cari Yönetimi": "Cari Yönetimi",
        "Yeni Cari": "Yeni Cari",
        "Cari Listele": "Cari Listele",
        "Cari İşlemleri": "Cari İşlemleri",
        "Raporlar": "Raporlar",
        "Satış Raporları": "Satış Raporları",
        "Ürün Raporları": "Ürün Raporları",
        "Gelir Gider Raporları": "Gelir Gider Raporları",
        "Çalışan Raporları": "Çalışan Raporları",
        "Provalar": "Provalar",
        "Prova Takvimi": "Prova Takvimi",
        "Liste Görünüm": "Liste Görünüm",
        "Kuaför Randevuları": "Kuaför Randevuları",
        "Kuaför Takvimi": "Kuaför Takvimi",
        "SMS Modülü": "SMS Modülü",
        "Tanımlamalar": "Tanımlamalar",
        "Ayarlar": "Ayarlar",
        "Duyurular": "Duyurular",
        "Yeni Duyuru Ekle": "Yeni Duyuru Ekle",
        "Henüz hiç müşteri eklememişsiniz, hemen yeni bir tane ekleyin!": "Henüz hiç müşteri eklememişsiniz, hemen yeni bir tane ekleyin!",
        "Duyuruyu Güncelle": "Duyuruyu Güncelle",
        "Sil": "Sil",
        "Vazgeç": "Vazgeç",
        "Ekle": "Ekle",
        "Kaydet": "Kaydet",
        "Başlık": "Başlık",
        "Tarih": "Tarih",
        "Randevular": "Randevular",
        "Randevu Kaydı": "Randevu Kaydı",
        "Müşteri Seçimi": "Müşteri Seçimi",
        "Ürün / Hizmet Seçimi": "Ürün / Hizmet Seçimi",
        "Başlangıç Tarihi": "Başlangıç Tarihi",
        "Başlangıç Saati": "Başlangıç Saati",
        "Bitiş Tarihi": "Bitiş Tarihi",
        "Bitiş Saati": "Bitiş Saati",
        "Bildirim SMS'i Gönder": "Bildirim SMS'i Gönder",
        "Randevu Detayı": "Randevu Detayı",
        "İlgili Calışan": "İlgili Calışan",
        "Başlangıç Zamanı": "Başlangıç Zamanı",
        "Bitiş Zamanı": "Bitiş Zamanı",
        "İlgili Hizmetler": "İlgili Hizmetler",
        "Etkinliği Sil": "Etkinliği Sil",
        "Yeni Ürün Oluştur": "Yeni Ürün Oluştur",
        "Barkod": "Barkod",
        "Birim": "Birim",
        "Henüz hiç randevu oluşturmamışsınız, hemen yeni bir tane ekleyin!": "Henüz hiç randevu oluşturmamışsınız, hemen yeni bir tane ekleyin!",
        "SMS ile Hatırlat": "SMS ile Hatırlat",
        "Tamamla": "Tamamla",
        "Mesaj": "Mesaj",
        "SMS Gönder": "SMS Gönder",
        "TL Borcumuz Mevcut": "TL Borcumuz Mevcut",
        "TL Ara Ödeme Yapıldı": "TL Ara Ödeme Yapıldı",
        "TL Alacak Mevcut": "TL Alacak Mevcut",
        "Ara Ödeme": "Ara Ödeme",
        "İşlem Oluştur": "İşlem Oluştur",
        "GELİR": "GELİR",
        "GİDER": "GİDER",
        "ALACAK": "ALACAK",
        "Görüntüle": "Görüntüle",
        "İptal": "İptal",
        "Gönder": "Gönder",

        "Fatura No": "Fatura No",
        "Kategori": "Kategori",
        "Ödeme Tarihi": "Ödeme Tarihi",
        "Ödeme Türü": "Ödeme Türü",
        "Ürün / Hizmet": "Ürün / Hizmet",
        "Birim Fiyatı": "Birim Fiyatı",
        "KDV Oranı": "KDV Oranı",
        "İskonto": "İskonto",
        "Adet": "Adet",
        "Toplam KDV": "Toplam KDV",
        "Toplam Fiyat": "Toplam Fiyat",
        "Kapat": "Kapat",
        "Kayıt Oluştur": "Kayıt Oluştur",
        "Ad Soyad": "Ad Soyad",
        "Telefon Numarası": "Telefon Numarası",
        "Ünvan": "Ünvan",
        "Vergi Dairesi": "Vergi Dairesi",
        "Vergi No": "Vergi No",
        "TC Kimlik No": "TC Kimlik No",
        "E-mail": "E-mail",
        "Firma Adı": "Firma Adı",
        "İl": "İl",
        "İlçe": "İlçe",
        "Adres": "Adres",
        "Hesap Adı": "Hesap Adı",
        "Banka Adı": "Banka Adı",
        "Şube Adı": "Şube Adı",
        "Şube Kodu": "Şube Kodu",
        "Hesap No": "Hesap No",
        "Döviz": "Döviz",
        "IBAN": "IBAN",
        "Yeni Hesap Ekle": "Yeni Hesap Ekle",
        "Müşteriler": "Müşteriler",
        "Filtreleri Temizle": "Filtreleri Temizle",
        "Yeni Müşteri Ekle": "Yeni Müşteri Ekle",
        "Henüz hiç müşteri eklememişsiniz, hemen yeni bir tane ekleyin": "Henüz hiç müşteri eklememişsiniz, hemen yeni bir tane ekleyin",
        "Alacaklı": "Alacaklı",
        "Borçlu": "Borçlu",
        "Bilgileri Güncelle": "Bilgileri Güncelle",
        "Limitsiz için": "Limitsiz için",
        "Terzi Fişi": "Terzi Fişi",
        "Ayarları Kaydet": "Ayarları Kaydet",
        "Satış Sözleşmesi": "Satış Sözleşmesi",
        "Sipariş Sözleşmesi": "Sipariş Sözleşmesi",
        "Kira Sözleşmesi": "Kira Sözleşmesi",
        "Kuru Temizleme Fişi": "Kuru Temizleme Fişi",
        "Yeni Oluştur": "Yeni Oluştur",
        "Henüz hiç kategori eklememişsiniz, hemen yeni bir tane ekleyin": "Henüz hiç kategori eklememişsiniz, hemen yeni bir tane ekleyin",
        "Tüm Çalışanlar": "Tüm Çalışanlar",
        "Çalışan Oluştur": "Çalışan Oluştur",
        "İzinde": "İzinde",
        "İzin Geçmişi": "İzin Geçmişi",
        "Maaşı Öde": "Maaşı Öde",
        "Avans Öde": "Avans Öde",
        "Güncelle": "Güncelle",
        "Ücret": "Ücret",
        "Ödeme Yap": "Ödeme Yap",
        "Henüz hiçbir kayıt girmemişsiniz": "Henüz hiçbir kayıt girmemişsiniz",
        "Şahıs Bilgileri": "Şahıs Bilgileri",
        "Kan Grubu": "Kan Grubu",
        "Ise Giris Tarihi": "Ise Giris Tarihi",
        "Maasi": "Maasi",
        "Iletisim Bilgileri": "Iletisim Bilgileri",
        "E-mail Adresi": "E-mail Adresi",
        "Satış Personeli": "Satış Personeli",
        "Stoku azalan ürünler": "Stoku azalan ürünler",
        "Henüz bir şey eklenmemiş": "Henüz bir şey eklenmemiş",
        "ciro": "ciro",
        "Adet Kirada": "Adet Kirada",
        "Adet Terzide": "Adet Terzide",
        "Adet Kuru Temizlemede": "Adet Kuru Temizlemede",
        "Kira Takvimi": "Kira Takvimi",
        "Kiraya Ver": "Kiraya Ver",
        "Düzenle": "Düzenle",
        "S.No": "S.No",
        "Kiraya Verilen Kişi": "Kiraya Verilen Kişi",
        "Kiraya Verilen Tarih": "Kiraya Verilen Tarih",
        "Teslim Alınan Tarih": "Teslim Alınan Tarih",
        "Tutar": "Tutar",
        "Durum": "Durum",
        "girin": "girin",
        "Satış Fiyatı": "Satış Fiyatı",
        "Kira Fiyatı": "Kira Fiyatı",
        "Yazdır": "Yazdır",
        "Kuru Temizleme Seçimi": "Kuru Temizleme Seçimi",
        "Ürün Seç": "Ürün Seç",
        "Oluştur": "Oluştur",
        "Kuru Temizleme Sözleşmesi İndir": "Kuru Temizleme Sözleşmesi İndir",
        "Kuru Temizlemeye Ürün Gönder": "Kuru Temizlemeye Ürün Gönder",
        "Kuru Temizleme Notu": "Kuru Temizleme Notu",
        "Kuru Temizleme Oluştur": "Kuru Temizleme Oluştur",
        "GSM": "GSM",
        "2. GSM": "2. GSM",
        "Terzi Seçimi": "Terzi Seçimi",
        "Terzi Sözleşmesi İndir": "Terzi Sözleşmesi İndir",
        "Teslim Al": "Teslim Al",
        "Ödenen Tutar": "Ödenen Tutar",
        "Teslim alınan tarih": "Teslim alınan tarih",
        "Bu kiranın (varsa) kalan ödemelerini tamamla": "Bu kiranın (varsa) kalan ödemelerini tamamla",

        "Gelecek Ürün Ekle": "Gelecek Ürün Ekle",
        "Limitsiz": "Limitsiz",
        "Alış Tarihi": "Alış Tarihi",
        "Teslim Tarihi": "Teslim Tarihi",
        "Toplam Ücret": "Toplam Ücret",
        "Peşinat": "Kapora",
        "Notlar": "Notlar",
        "İçeri Al": "İçeri Al",
        "Stok": "Stok",
        "Gelecek Stok": "Gelecek Stok",
        "Kira Fiyatı Barkodda Görünsün": "Kira Fiyatı Barkodda Görünsün",
        "Terziye Ürün Gönder": "Terziye Ürün Gönder",
        "Toplam Genel Gider": "Toplam Genel Gider",
        "İşlem Sayısı": "İşlem Sayısı",
        'Ödeme Şekli': 'Ödeme Şekli',
        "BORÇ": "BORÇ",
        "Ödeme Alındı": "Ödeme Alındı",
        "Ödeme Tamamla": "Ödeme Tamamla",
        "Personel Raporları": "Personel Raporları",
        "Toplam Çalışan": "Toplam Çalışan",
        "Çalışanların Toplam Satış Geliri": "Çalışanların Toplam Satış Geliri",
        "Çalışanların Toplam Kira Geliri": "Çalışanların Toplam Kira Geliri",
        "Çalışanların Bu Yılki İzinleri": "Çalışanların Bu Yılki İzinleri",
        "Sonraki Fatura Tarihi": "Sonraki Fatura Tarihi",
        "Sonraki Vade": "Sonraki Vade",
        "Gelir Gider Raporlar": "Gelir Gider Raporlar",
        "Gelir": "Gelir",
        "Gider": "Gider",
        "Gelire Dönüştür": "Gelire Dönüştür",
        "Toplam Gelir": "Toplam Gelir",
        "Toplam Gider": "Toplam Gider",
        "NET KÂR": "NET KÂR",
        "Cari Kayıtları": "Cari Kayıtları",
        'Tümü': 'Tümü',
        'Nakit': 'Nakit',
        'Çek': 'Çek',
        'Senet': 'Senet',
        'Kredi Kartı': 'Kredi Kartı',
        'Havale / EFT': 'Havale / EFT',

        "Toplam Kira Adedi": "Toplam Kira Adedi",
        "Toplam Kira Geliri": "Toplam Kira Geliri",
        "Toplam Satış Adedi": "Toplam Satış Adedi",
        "Toplam Satış Geliri": "Toplam Satış Geliri",
        "Kullanıcı Bilgileri": "Kullanıcı Bilgileri",
        "Telefon": "Telefon",
        "SMS Ayarları": "SMS Ayarları",
        "Bulutfon panelinde Ayarlar > API Kullanıcıları bölümünden bir kullanıcı oluşturup API Key'i giriniz.": "Bulutfon panelinde Ayarlar > API Kullanıcıları bölümünden bir kullanıcı oluşturup API Key'i giriniz.",
        "NetGSM paneline girişte kullandığınız kullanıcı adı ve şifrenizi giriniz.": "NetGSM paneline girişte kullandığınız kullanıcı adı ve şifrenizi giriniz.",
        "IletiMerkezi panelinden Ayarlar bölümünden aldığınız API bilgilerini giriniz.": "IletiMerkezi panelinden Ayarlar bölümünden aldığınız API bilgilerini giriniz.",
        "JetSMS paneline girişte kullandığınız kullanıcı adı ve şifrenizi giriniz.": "JetSMS paneline girişte kullandığınız kullanıcı adı ve şifrenizi giriniz.",
        "SMSVitrini paneline girişte kullandığınız kullanıcı adı ve şifrenizi giriniz.": "SMSVitrini paneline girişte kullandığınız kullanıcı adı ve şifrenizi giriniz.",
        "OrganikSMS panelinden oluşturduğunuz API kullanıcısına ait API Key'i giriniz.": "OrganikSMS panelinden oluşturduğunuz API kullanıcısına ait API Key'i giriniz.",
        "Servis Sağlayıcı": "Servis Sağlayıcı",
        "SMS Başlığı": "SMS Başlığı",
        "API Key": "API Key",
        "Kullanıcı Adı": "Kullanıcı Adı",
        "Şifre": "Şifre",
        "Secret (Gizli Şifre)": "Secret (Gizli Şifre)",
        "Firma Bilgileri": "Firma Bilgileri",
        "Şifreyi Değiştir": "Şifreyi Değiştir",
        "Kullanıcılar": "Kullanıcılar",
        "Eski Şifre": "Eski Şifre",
        "Yeni Şifre": "Yeni Şifre",
        "Yeni Şifre Tekrar": "Yeni Şifre Tekrar",
        "Şifre Değiştir": "Şifre Değiştir",
        "Şifreyi Güncelle": "Şifreyi Güncelle",
        "Mağaza Lisans Numaranız:": "Mağaza Lisans Numaranız:",
        "tarihinden beri": "tarihinden beri",
        "sistemi kullanıyorsunuz.": "sistemi kullanıyorsunuz.",
        "Yetkili Kişi": "Yetkili Kişi",
        "Yetkili Telefon": "Yetkili Telefon",
        "Kodu Tekrar Gönder": "Kodu Tekrar Gönder",
        "Telefonu Doğrula": "Telefonu Doğrula",
        "Adres Bilgileri": "Adres Bilgileri",
        "Çıktı Ayarları": "Çıktı Ayarları",
        "Barkod'da Satış Fiyatını Yazdır": "Barkod'da Satış Fiyatını Yazdır",
        "Barkod'da Kira Fiyatını Yazdır": "Barkod'da Kira Fiyatını Yazdır",
        "Barkod'da Mağaza Logosunu Yazdır": "Barkod'da Mağaza Logosunu Yazdır",
        "Satış Ve Kiralamada Otomatik Sms Gönder": "Satış Ve Kiralamada Otomatik Sms Gönder",
        "seçildi": "seçildi",
        "Tümünü seç": "Tümünü seç",
        "SMS MODÜLÜ": "SMS MODÜLÜ",
        "Toptan Ürünler": "Toptan Ürünler",
        "Adet Aktif Sipariş": "Adet Aktif Sipariş",
        "Görselleri Görüntüle": "Görselleri Görüntüle",
        "Sipariş Ver": "Sipariş Ver",
        "Görsel": "Görsel",
        "Satış Fiyatına KDV Dahil": "Satış Fiyatına KDV Dahil",
        "Not": "Not",
        "Ürün Siparişleri": "Ürün Siparişleri",
        "Değer": "Değer",
        "Adresi": "Adresi",
        'Bu hafta': 'Bu hafta',
        'Bu ay': 'Bu ay',
        'Tarih seç': 'Tarih seç',
        "Bugünkü Provalar": "Bugünkü Provalar",
        "Bugün hiç prova yok": "Bugün hiç prova yok",
        "Hatırlat": "Hatırlat",
        "Yaklaşan Borçlar": "Yaklaşan Borçlar",
        "Hiç yaklaşan borcunuz yok": "Hiç yaklaşan borcunuz yok",
        "Bugun Kiraya Verilecek Ürünler": "Bugun Kiraya Verilecek Ürünler",
        "Bugun Kiraya Verilecek Ürün Yok": "Bugun Kiraya Verilecek Ürün Yok",
        "Bugun Kiradan Teslim Alınacak Ürünler": "Bugun Kiradan Teslim Alınacak Ürünler",
        "Bugun alınacak Ürün Yok": "Bugun alınacak Ürün Yok",
        "BUGÜN:": "BUGÜN:",
        "TESLİMAT": "TESLİMAT",
        "KİRADA OLAN": "KİRADA OLAN",
        "KURU TEMİZLEME": "KURU TEMİZLEME",
        "TERZİ": "TERZİ",
        "KREDİ": "KREDİ",
        "Kredi": "Kredi",
        "Uygun Satış Personeli Bulunamadı": "Uygun Satış Personeli Bulunamadı",
        "İade Tarih": "İade Tarih",
        "Düğün Tarihi": "Düğün Tarihi",
        "Fotoğraf Çekim Tarihi Tarihi": "Fotoğraf Çekim Tarihi Tarihi",
        "Ödeme Tipi": "Ödeme Tipi",
        "Ürün Ekle": "Ürün Ekle",
        "Toplam": "Toplam",
        "Sözleşmesi İndir": "Sözleşmesi İndir",
        "Sipariş Sözleşmesi İndir": "Sipariş Sözleşmesi İndir",


        'Lütfen Önce Müşteri Seçiniz!': 'Lütfen Önce Müşteri Seçiniz!',
        "Müşteri": "Müşteri",
        "Ürün": "Ürün",
        "Kuaför Randevu Kaydı": "Kuaför Randevu Kaydı",
        "Kâr": "Kâr",
        "Yeni İşlem Sayısı": "Yeni İşlem Sayısı",
        "Göğüs": "Göğüs",
        "Göğüs Üstü": "Göğüs Üstü",
        "Bel": "Bel",
        "Kol Boyu": "Kol Boyu",
        "Pazu": "Pazu",
        "Bilek": "Bilek",
        "Topuk Boyu": "Topuk Boyu",
        "Gelinin Boyu": "Gelinin Boyu",
        "Sipariş Notu": "Sipariş Notu",
        "Müşteri Oluştur": "Müşteri Oluştur",
        "GSM(Yakını)": "GSM(Yakını)",
        "Açıklama": "Açıklama",
        "Sipariş Ölçü Bilgileri": "Sipariş Ölçü Bilgileri",
        'Ürün Adı': 'Ürün Adı',
        'KDV': 'KDV',
        'İndirim(Tutar)': 'İndirim(Tutar)',
        'İndirim(Oran)': 'İndirim(Oran)',
        'Maaş': 'Maaş',
        'Kalan Ödeme': 'Kalan Ödeme',
        'Saat': 'Saat',
        'Son Ödeme': 'Son Ödeme',
        "Alış Fiyatı": "Alış Fiyatı",
        "Kira Getirisi": "Kira Getirisi",

        "Verilen Tarih": "Verilen Tarih",
        "Teslim Alınacak Tarih": "Teslim Alınacak Tarih",
        "Son Ödeme Tarihi":"Son Ödeme Tarihi",
        "Damat Bilgileri":"Damat Bilgileri",
        "Damat Telefonu":"Damat Telefonu",
        "Damat Ad Soyad":"Damat Ad Soyad",
        "Dil Secenekleri":"Dil Seçenekleri",
        "Bildirimler" : "Bildirimler",
        "Sistem Yetkilisi (Bayileri İzleyebilir ve Süper Yetkilidir)":"Sistem Yetkilisi (Bayileri İzleyebilir ve Süper Yetkilidir)",

    }
}